import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-16 h-16 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/281fbea3ff24195271af1eb3bd4da899.jpeg"
                  alt="Mow and Snow Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold">Mow and Snow</h3>
                <p className="text-sm text-white/80">All-Season Landscaping</p>
              </div>
            </div>
            <p className="text-white/90 mb-4 leading-relaxed">
              Professional landscaping and snow removal services throughout the Greater Toronto Area. One flat monthly rate covers everything you need, year-round.
            </p>
            <div className="flex items-center">
              <a
                href="https://www.instagram.com/mowandsnowco?igsh=MWFodGJvdzdmenVtOA%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-600 hover:text-white transition-all cursor-pointer"
                title="See our work on Instagram @mowandsnowco"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Services', 'Pricing', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-white/80 hover:text-yellow-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item}
                  </button>
                </li>
              ))}
              <li>
                <Link
                  to="/sitemap"
                  className="text-white/80 hover:text-yellow-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-lg mt-0.5"></i>
                <a href="tel:+16479837924" className="text-white/80 hover:text-yellow-400 transition-colors cursor-pointer">
                  (647) 983-7924
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-lg mt-0.5"></i>
                <a
                  href="mailto:info@mowandsnow.co"
                  className="text-white/80 hover:text-yellow-400 transition-colors cursor-pointer"
                >
                  info@mowandsnow.co
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-lg mt-0.5"></i>
                <span className="text-white/80">Greater Toronto Area, ON</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/80 text-sm">© 2026 Mow and Snow. All rights reserved.</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 hover:text-yellow-400 text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}